<div class="row">
    <div class="col">
        <app-add-new-province [provincesList]="provincesList" [regionsOptions]="regionsOptions" [regionsList]="regionsList"></app-add-new-province>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Region</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let province of provincesList;  let i = index">
                        <tr [ngClass]="{'bluBottomLine': i === provincesList.length - 1}">
                            <ng-container *ngIf="choosenEditProvince.id === province.id; else displayTemplate">
                                <td colspan="4">
                                    <app-edit-province-form [province]="choosenEditProvince" [provincesList]="provincesList" [regionsList]="regionsList" [regionsOptions]="regionsOptions" (getCancelEditModeEvent)="cancelProvinceEditMode()" (geResetProvincesList)="resetProvincesList($event)">
                                    </app-edit-province-form>
                                </td>
                            </ng-container>
                            <ng-template #displayTemplate>
                                <td scope="row">{{province.id}}</td>
                                <td>{{province.name}}</td>
                                <td>
                                    {{province.region.name}}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                                        <button type="button" class="btn btn-link" title="Edit" (click)="enableEditProvince(province)"><i class="fa fa-edit"></i></button>
                                        <!--
                                        <button type="button" class="btn btn-link" placement="top" [ngbTooltip]="Delete" (click)="showConfirmDeleteDialog(province.id)"><i class="fa fa-trash"></i></button>
                                        -->
                                    </div>
                                </td>
                            </ng-template>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-confirm-dialog-model #confirmDeleteProvinceDialog (getResult)="getDeleteProvinceDecision($event)" modalTitle="Province Elimination" modalContent="Do you want to delete this province?" denyText="NO" acceptText="YES">
</app-confirm-dialog-model>
